import Button, { ButtonProps } from '@mui/material/Button';
import amber from '@mui/material/colors/amber';
import blue from '@mui/material/colors/blue';
import green from '@mui/material/colors/green';
import red from '@mui/material/colors/red';
import { Theme } from '@mui/material/styles';
import { withStyles } from "@mui/styles";
import classNames from 'classnames';
import * as React from 'react';

function styled(Component: React.ComponentType<ButtonProps>) {
    return (style: any, options?: any) => {
        function StyledComponent(props: ButtonProps) {
            const { classes, className, ...other } = props;
            return <Component className={classNames(classes.root, className)} {...other} />;
        }
        const styles = typeof style === 'function' ? (theme: Theme) => ({ root: style(theme) }) : { root: style };
        return withStyles(styles, options)(StyledComponent);
    };
}



export const MuiButtonDanger = styled(Button)((theme: Theme) => ({
    backgroundColor: red["500"],
    color: theme.palette.common.white,
}));

export const MuiButtonWarning = styled(Button)((theme: Theme) => ({
    backgroundColor: amber["500"],
    color: theme.palette.common.white
}));

export const MuiButtonSuccess = styled(Button)((theme: Theme) => ({
    backgroundColor: green["500"],
    color: theme.palette.common.white
}));

export const MuiButtonInfo= styled(Button)((theme: Theme) => ({
    backgroundColor: blue["500"],
    color: theme.palette.common.white
}));

export const MuiButtonPrimary = styled(Button)((theme: Theme) => ({
    backgroundColor: blue["800"],
    color: theme.palette.common.white
}));

export const MuiButtonTransparent = styled(Button)((theme: Theme) => ({
    backgroundColor: "transparent",
    color: theme.palette.common.black
}));
